import { render, staticRenderFns } from "./BlockDeletedAdmins.vue?vue&type=template&id=4f7ac72a&scoped=true&"
import script from "./BlockDeletedAdmins.vue?vue&type=script&lang=js&"
export * from "./BlockDeletedAdmins.vue?vue&type=script&lang=js&"
import style0 from "./BlockDeletedAdmins.vue?vue&type=style&index=0&id=4f7ac72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7ac72a",
  null
  
)

export default component.exports